import { IanaZone, IsoInstant } from '#.shared/dates/types.ts'
import { instantToDateTime } from '#.shared/dates/utils/convert.ts'
import { Duration } from 'luxon'
import z from 'zod'

import { ShiftID } from './shift'
import { TimesheetBreak } from '../../timesheets/models/timesheetBreak'

export const BreakDefinitionID = z.string().brand<'BreakDefinitionID'>()
export type BreakDefinitionID = z.infer<typeof BreakDefinitionID>

export const BreakDefinition = z
  .object({
    id: z.string(),
    time_zone_id: IanaZone,
    shift_id: z.string().nullable(),
    timesheet_id: z.string().nullable(),
    label: z.string(),
    type: z.string(),
    scheduled_start: IsoInstant.nullable(),
    scheduled_end: IsoInstant.nullable(),
    earliest_start: IsoInstant.nullable(),
    latest_start: IsoInstant.nullable(),
    duration_minutes: z.number(),
    mandatory: z.boolean(),
    paid: z.boolean(),
    break: z.object({
        data: TimesheetBreak.nullable(),
    }).optional(),
  })
  .transform((obj) => ({
    id: BreakDefinitionID.parse(obj.id),
    timeZoneId: obj.time_zone_id,
    shiftId: obj.shift_id ? ShiftID.parse(obj.shift_id) : null,
    timesheetId: obj.timesheet_id ? obj.timesheet_id : null,
    label: obj.label,
    type: obj.type,
    scheduledStart: obj.scheduled_start
      ? instantToDateTime(obj.scheduled_start, obj.time_zone_id)
      : null,
    scheduledEnd: obj.scheduled_end
      ? instantToDateTime(obj.scheduled_end, obj.time_zone_id)
      : null,
    earliestStart: obj.earliest_start
      ? instantToDateTime(obj.earliest_start, obj.time_zone_id)
      : null,
    latestStart: obj.latest_start
      ? instantToDateTime(obj.latest_start, obj.time_zone_id)
      : null,
    duration: Duration.fromObject({ minutes: obj.duration_minutes }),
    mandatory: obj.mandatory,
    paid: obj.paid,
    break: obj.break?.data ? TimesheetBreak.parse(obj.break.data) : null,
  }))

export type BreakDefinitionSchema = z.input<typeof BreakDefinition>
export type BreakDefinition = z.output<typeof BreakDefinition>

// export const TimesheetBreak = z
//   .object({
//     id: z.string(),
//     time_zone_id: IanaZone,
//     shift_id: z.string().nullable(),
//     timesheet_id: z.string().nullable(),
//     label: z.string(),
//     type: z.string(),
//     scheduled_start: IsoInstant.nullable(),
//     scheduled_end: IsoInstant.nullable(),
//     earliest_start: IsoInstant.nullable(),
//     latest_start: IsoInstant.nullable(),
//     duration_minutes: z.number(),
//     mandatory: z.boolean(),
//     paid: z.boolean(),
//   })
//   .transform((obj) => ({
//     id: BreakDefinitionID.parse(obj.id),
//     timeZoneId: obj.time_zone_id,
//     shiftId: obj.shift_id ? ShiftID.parse(obj.shift_id) : null,
//     timesheetId: obj.timesheet_id ? obj.timesheet_id : null,
//     label: obj.label,
//     type: obj.type,
//     scheduledStart: obj.scheduled_start
//       ? instantToDateTime(obj.scheduled_start, obj.time_zone_id)
//       : null,
//     scheduledEnd: obj.scheduled_end
//       ? instantToDateTime(obj.scheduled_end, obj.time_zone_id)
//       : null,
//     earliestStart: obj.earliest_start
//       ? instantToDateTime(obj.earliest_start, obj.time_zone_id)
//       : null,
//     latestStart: obj.latest_start
//       ? instantToDateTime(obj.latest_start, obj.time_zone_id)
//       : null,
//     duration: Duration.fromObject({ minutes: obj.duration_minutes }),
//     mandatory: obj.mandatory,
//     paid: obj.paid,
//   }))

// export type TimesheetBreakSchema = z.input<typeof TimesheetBreak>
// export type TimesheetBreak = z.output<typeof TimesheetBreak>
